import {takeEvery} from 'redux-saga/effects';
import {LOGIN_USER_FAIL} from '../reducers2/login';
import _ from "lodash";
import history from "../libs/history";

export function fetchFail(action) {
    if (!!_.get(action, "error.response.errors.passwordWeak")) history.push('/change-password', {email:_.get(action, "error.response.errors.email")});
}

export function* watchLogin() {
    yield takeEvery(LOGIN_USER_FAIL, fetchFail);
}

export default watchLogin;